import React from 'react';
import { Button, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { DetailsSectionWrapper } from 'app/main/components/page-layouts';

import DemsRecipientsAddSingleDialog from '../../dems-recipients/DemsRecipientsAddSingleDialog';
import DemsRecipientsAddFilterDialog from '../../dems-recipients/DemsRecipientsAddFilterDialog';
import DemsRecipientsAddQueryDialog from '../../dems-recipients/DemsRecipientsAddQueryDialog';
import DemsRecipientsImportDialog from '../../dems-recipients/DemsRecipientsImportDialog';

interface DemsDetailsSectionAddRecipientsProps {
	demsUid: string;
	isLoading: boolean;
	updateRefresh: VoidFunction;
}

export default function DemsDetailsSectionAddRecipients(props: DemsDetailsSectionAddRecipientsProps) {
	const { t } = useSettings();

	const [type, setType] = React.useState('all');
	const handleTypeChange = event => setType(event.target.value);

	const table = type === 'all' ? 'companies' : type;
	const tables = type === 'all' ? ['companies', 'people'] : type !== 'mails' ? [type] : [];

	const defaultFilters = [
		{ filt_field: 'mail_blocked', filt_clause: 'not_equal', filt_value: 1 },
		{ filt_field: 'comp_deleted', filt_clause: 'not_equal', filt_value: 1 },
		{ filt_field: 'comp_blocked', filt_clause: 'not_equal', filt_value: 1 },
		{ filt_field: 'peop_deleted', filt_clause: 'not_equal', filt_value: 1 },
		{ filt_field: 'peop_blocked', filt_clause: 'not_equal', filt_value: 1 },
		{ filt_field: 'mail_unsubscribed_dems_uid', filt_clause: 'is_null' },
		{ filt_field: 'mail_table', filt_clause: 'in', filt_value: tables }
	];

	const [openAddRowDialog, setOpenAddRowDialog] = React.useState(false);
	const switchOpenAddRowDialog = () => setOpenAddRowDialog(state => !state);

	const [openAddFilterRowsDialog, setOpenAddFilterRowsDialog] = React.useState(false);
	const switchOpenAddFilterRowsDialog = () => setOpenAddFilterRowsDialog(state => !state);

	const [openAddQueryRowsDialog, setOpenAddQueryRowsDialog] = React.useState(false);
	const switchOpenAddQueryRowsDialog = () => setOpenAddQueryRowsDialog(state => !state);

	const [openImportDialog, setOpenImportDialog] = React.useState(false);
	const switchOpenImportDialog = () => setOpenImportDialog(state => !state);

	return (
		<>
			<DetailsSectionWrapper
				title={t('DEMS_SECTION_ADD_TITLE')}
				subheader={
					<RadioGroup row name="type" value={type} onChange={handleTypeChange}>
						<FormControlLabel
							value="all"
							control={<Radio color="primary" />}
							label={t('DEMS_SECTION_ADD_ALL')}
						/>
						<FormControlLabel
							value="companies"
							control={<Radio color="primary" />}
							label={t('DEMS_SECTION_ADD_COMPANY')}
						/>
						<FormControlLabel
							value="people"
							control={<Radio color="primary" />}
							label={t('DEMS_SECTION_ADD_PERSON')}
						/>
						<FormControlLabel
							value="mails"
							control={<Radio color="primary" />}
							label={t('DEMS_SECTION_ADD_MAIL')}
						/>
					</RadioGroup>
				}
				actions={
					<>
						<Button
							startIcon={<Icon icon="search" />}
							onClick={switchOpenAddRowDialog}
							disabled={props.isLoading}
						>
							{t('SEARCH_BUTTON')}
						</Button>
						<Button
							startIcon={<Icon icon="filter" />}
							onClick={switchOpenAddFilterRowsDialog}
							disabled={props.isLoading}
						>
							{t('FILTER_BUTTON')}
						</Button>
						<Button
							startIcon={<Icon icon="file-tree" />}
							onClick={switchOpenAddQueryRowsDialog}
							disabled={props.isLoading}
						>
							{t('FILTER_QUERY_BUILDER_BUTTON')}
						</Button>
						<Button
							startIcon={<Icon icon="table-arrow-left" />}
							onClick={switchOpenImportDialog}
							disabled={props.isLoading}
						>
							{t('IMPORT_BUTTON')}
						</Button>
					</>
				}
			/>
			{/* ADD SINGLE RECIPIENT DIALOG */}
			<DemsRecipientsAddSingleDialog
				openDialog={openAddRowDialog}
				switchOpenDialog={switchOpenAddRowDialog}
				table={table}
				demsUid={props.demsUid}
				defaultFilters={defaultFilters}
				updateRefresh={props.updateRefresh}
			/>
			{/* ADD RECIPIENTS FILTER DIALOG */}
			<DemsRecipientsAddFilterDialog
				openDialog={openAddFilterRowsDialog}
				switchOpenDialog={switchOpenAddFilterRowsDialog}
				demsUid={props.demsUid}
				table={table}
				defaultFilters={defaultFilters}
				updateRefresh={props.updateRefresh}
			/>
			{/* ADD RECIPIENTS ADVANCED FILTER DIALOG */}
			<DemsRecipientsAddQueryDialog
				openDialog={openAddQueryRowsDialog}
				switchOpenDialog={switchOpenAddQueryRowsDialog}
				demsUid={props.demsUid}
				table={table}
				defaultFilters={defaultFilters}
				updateRefresh={props.updateRefresh}
			/>
			{/* IMPORT RECIPIENTS DIALOG */}
			<DemsRecipientsImportDialog
				openDialog={openImportDialog}
				switchOpenDialog={switchOpenImportDialog}
				demsUid={props.demsUid}
				table={table}
				updateRefresh={props.updateRefresh}
			/>
		</>
	);
}
